var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"number-control-button btn btn-outline-leuco",on:{"click":function($event){return _vm.emitMethod()}}},[(_vm.isPlus)?_c('i',{staticClass:"bi bi-plus-lg"}):_c('i',{staticClass:"bi bi-dash-lg"})])}
var staticRenderFns = []

export { render, staticRenderFns }